<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    Relação de Pagamentos e Rentenções
                    <btn-exportar
                        v-if="pagamentos.length > 0 && ($temAcessoView('DIRFS-02') || $temAcessoView('FORN-DIRF-00'))"
                        class="float-right"
                        :dirfBeneficiarioId="dirfBeneficiarioId"
                        :beneficiario="beneficiario"
                        :anoCalendario="anoCalendario"
                        :dirfsServicos="dirfsServicos"
                        :fornecedorId="fornecedorId"
                    ></btn-exportar>
                </h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblPagamentos"
                    :itens="pagamentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :mostrarFiltro="false"
                >
                    <template slot="valorPago" slot-scope="data">
                        {{
                        data.valorPago | currency
                        }}
                    </template>
                    <template slot="valorRetido" slot-scope="data">
                        {{
                        data.valorRetido | currency
                        }}
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import BtnExportar from './BtnExportarPagamentos'

export default {
	props: {
		pagamentos: {
			type: Array,
			default: () => []
		},

		dirfBeneficiarioId: {
			type: String,
			default: () => ''
		},

		beneficiario: {
			type: String,
			default: () => ''
		},

		anoCalendario: {
			type: String,
			default: () => ''
		},

		dirfsServicos: {
			type: Object,
			default: () => {}
		},

		fornecedorId: {
			type: String,
			default: () => null
		}
	},

	components: { BtnExportar },

	data() {
		return {
			campos: [
				{
					key: 'mes',
					label: 'Mês'
				},
				{
					key: 'codigoRetencao',
					label: 'Código Retenção',
					tdClass: 'text-center'
				},
				{
					key: 'descricaoRetencao',
					label: 'Descrição da Retenção'
				},
				{
					key: 'valorPago',
					label: 'Valor Pago',
					tdClass: 'text-nowrap text-right'
				},
				{
					key: 'valorRetido',
					label: 'Valor Retido',
					tdClass: 'text-nowrap text-right'
				}
			],
			itensPorPagina: 0
		}
	},

	methods: {},

	created() {},

	computed: {},

	watch: {}
}
</script>
